import { MultiString } from "../../../library-js/i18n/MultiString";

export class UserLocales
{
  static readonly loggingInLoaderScreenInfo:MultiString = { en:"LOGGING IN", de:"MELDE AN" };
  static readonly loginButtonLinkInfo:MultiString = { en:"login", de:"anmeldung" };

  static readonly loginConfirmationTitle:MultiString = { en:"LOGIN", de:"ANMELDUNG" };
  static readonly loginConfirmationContent:MultiString = 
  { 
    en:"Your login was successfull!", 
    de:"Dein Anmeldung war erfolgreich!" 
  };

  static readonly changePasswordLoaderScreenInfo:MultiString = { en:"CHANGING PASSWORD", de:"ÄNDERE PASSWORT" };
  static readonly changePasswordButtonLinkInfo:MultiString = { en:"change-password", de:"passwort-ändern" };
}